<script setup lang="ts">
const props = defineProps<{
  label?: string
  modelValue?: number | string
  value: number | string
}>()
const emit =
  defineEmits<(e: 'update:modelValue', values: number | string) => void>()

const localValue = computed<any>({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <div>
    <label
      class="flex flex-row items-center group cursor-pointer select-none"
      @click.stop
    >
      <input
        v-model="localValue"
        type="radio"
        :value="value"
        :name="label"
        class="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300"
      />

      <slot />
    </label>
  </div>
</template>
